import type { User } from '@/api/queries/user/types/user';

export default function useFormatProfessionalInfos(user: User) {
  return {
    accurateJob: user.accurate_job_title,
    jobTitle: user.job_title,
    industryId: user.industry_id,
    degreeId: user.degree_level_id,
    experience: user.profile?.experience,
  };
}
